import { createAction } from '@reduxjs/toolkit';
import karmaEarnGameSlice from './slice';

export const fetchKarmaEarnGame = createAction('karmaEarnGame/fetchKarmaEarnGame');

export const { receiveItem, reset } = karmaEarnGameSlice.actions;
